import type { OrgRole } from '@allemnii-pulse/shared';

export interface MeResponse {
  orgs: Array<{ id: string; name: string; role: OrgRole }>;
}

let primed: MeResponse | null = null;

/**
 * POST /api/auth/session already returns the same `orgs` list GET /api/me does, so AuthProvider
 * hands it over here and OrgProvider picks it up on mount instead of spending a second
 * round-trip on GET /me. Call `consumePrimedMe` to take it (or fall back to a normal fetch if
 * there isn't one, e.g. after a manual `refresh()`).
 */
export function primeMe(me: MeResponse): void {
  primed = me;
}

export function consumePrimedMe(): MeResponse | null {
  const result = primed;
  primed = null;
  return result;
}
